import React, { FC, useMemo } from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { detectBrowser, BrowserType } from 'utils';

const chromeSteps = (
  <ol>
    <li>Click the 🔒 lock icon next to the website address</li>
    <li>Find <strong>Location</strong></li>
    <li>Select <strong>Allow</strong></li>
    <li>Refresh this page</li>
  </ol>
);

const edgeSteps = (
  <ol>
    <li>Click the 🔒 lock icon next to the address bar</li>
    <li>Find <strong>Location</strong></li>
    <li>Select <strong>Allow</strong></li>
    <li>Refresh this page</li>
  </ol>
);

const safariMacSteps = (
  <ol>
    <li>
      Open <strong>Safari → Settings</strong>
    </li>
    <li>
      Go to <strong>Websites → Location</strong>
    </li>
    <li>
      Find this website and set to <strong>Allow</strong>
    </li>
    <li>Refresh the page</li>
  </ol>
);

const safariIosSteps = (
  <ol>
    <li>
      Open <strong>Settings</strong>
    </li>
    <li>
      Go to <strong>Privacy &amp; Security → Location Services</strong>
    </li>
    <li>
      Tap <strong>Safari Websites</strong>
    </li>
    <li>
      Select <strong>While Using the App</strong>
    </li>
  </ol>
);

const stepsMap: Record<BrowserType, React.ReactNode> = {
  chrome: chromeSteps,
  edge: edgeSteps,
  'safari-mac': safariMacSteps,
  'safari-ios': safariIosSteps,
  other: chromeSteps,
};

const LocationBlockedContent: FC = () => {
  const browser = useMemo(() => detectBrowser(), []);
  const steps = stepsMap[browser];

  return (
    <Box>
      <Typography variant="body2">
        We can&apos;t access your location right now. To allow access:
      </Typography>
      {steps}
      <Typography variant="caption" color="textSecondary">
        You may need to reload this page after updating settings.
      </Typography>
    </Box>
  );
};

export default LocationBlockedContent;
